import { MAP_TYPES } from '@deck.gl/carto';

const HISTORICAL_CRASH_SOURCE_ID = 'historicalCrashSource';

const source = {
  id: HISTORICAL_CRASH_SOURCE_ID,
  type: MAP_TYPES.TABLE,
  connection: 'bmpo-smartmetro-09142026',
  data: 'us-con-gcp-npr-0000424-011325.diamond.H3_BSAP_Collision_Data_Final',
};

export default source;
